/**
 * Page identity helpers for SPA navigation tracking.
 */

/**
 * Explicit view call that the CDN auto-fires for a landing page of a given type.
 */
export type LandingViewKind = 'viewItem' | 'viewItemList' | 'search' | 'viewCart' | 'homepage';

export const LANDING_VIEW_KIND: Record<string, LandingViewKind> = {
  product: 'viewItem',
  collection: 'viewItemList',
  search: 'search',
  cart: 'viewCart',
  index: 'homepage',
};

/**
 * Key that identifies the current virtual page: the pathname. Query-only
 * changes (e.g. ?variant=) stay on the same page. A new search term on a
 * search page is a new results page — tracked separately, by term, so a
 * route tracker and a search tracker calling for the same URL agree.
 */
export function currentPageKey(): string {
  if (typeof window === 'undefined') return '';
  return window.location.pathname;
}

/**
 * Variant selected through Shopify's `?variant=<id>` URL convention.
 */
export function variantIdFromUrl(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const value = new URLSearchParams(window.location.search).get('variant');
    return value && /^\d+$/.test(value) ? value : undefined;
  } catch {
    return undefined;
  }
}
